import { render, staticRenderFns } from "./SettingsDesign.vue?vue&type=template&id=a8c042e4&"
import script from "./SettingsDesign.vue?vue&type=script&lang=js&"
export * from "./SettingsDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports